<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6  hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        select-all
        v-bind:pagination.sync="pagination"
        item-key="number"
        :items="bonusComplianceLiquidation"
        :headers="headers"
        class="v-table-list theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th width="1%" class="column"></th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="selected = props.item.number">
            <td width="1%">
               <v-checkbox hide-details  v-model="selectRow[props.index]" @change="uniqueCheck(props.item.number, props.index)"></v-checkbox>
            </td>
            <td class="text-xs-left cut-text">{{ props.item.FechaCreacion }}</td>
            <td class="text-xs-left cut-text">{{ props.item.TipoBono }}</td>
            <td class="text-xs-left cut-text">{{ props.item.SistemaFuente}}</td>
            <td class="text-xs-left cut-text">{{ props.item.NombreAgencia }}</td>
            <td class="text-xs-left cut-text">{{ props.item.LineaNegocio }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.AnioComercial }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.SemanaComercial }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Ramo }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Agrupador }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Poliza }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Anexo }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Prima | currency }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Identificacion }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.NombreCliente }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.FechaEmision }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.FechaIngreso }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.ValorIngreso | currency }}</td>
            <td class="text-xs-left cut-text" >{{ props.item.Estado }}</td>
            
          </tr>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters([
      "loadingBonusCompliance",
      "bonusComplianceLiquidation",
      "agency"
    ])
  },
  mounted() {
    this.$store.dispatch("getBonusComplianceLiquidation");
  },
  methods: {
    nzDate: nzDate,
    uniqueCheck(e,index){
      let select= this.selectRow[index];
      for(let i=0;i<this.selectRow.length;i++)
      {
        if(index!=i)
        {
          this.selectRow[i]=false;
        }
      }
      if(!this.selectRow[index]){
     this.selectedValue=null;
      }else{
      this.selectedValue=e;
      }
    },
    changeSort(column) {
      this.selectedValue = null;
       this.selectRow= [];
       this.additionalGrouped=[]
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additionalGrouped[0]=this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additionalGrouped[0]=this.selectedValue;
      }
    },
    refresh() {
      this.$store.dispatch("getBonusComplianceLiquidation").then(()=>{
         
          this.selectedValue=null;
          this.additionalGrouped= [];
      });
    },
    enter() {
      this.$store.dispatch("getBonusComplianceLiquidation", this.searchValue);
    }
  },
  watch: {
    loadingBonusCompliance(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      }
    },
    agency(val) {
      this.$store.dispatch("getBonusComplianceLiquidation");
    }
  },
  data() {
    return {
      selectedValue:null,
       selectRow:[],
      additionalGrouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "FechaCreacion"
      },
      selected: undefined,
      headers: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.date"),
          value: "FechaCreacion",
          width: "19%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.liquidation"),
          value: "TipoBono",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.branch"),
          value: "SistemaFuente",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.agent"),
          value: "NombreAgencia",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.toPay"),
          value: "LineaNegocio",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "AnioComercial",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "SemanaComercial",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Ramo",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Agrupador",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Poliza",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Anexo",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Prima",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Identificacion",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "NombreCliente",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "FechaEmision",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "FechaIngreso",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "ValorIngreso",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "Estado",
          width: "20%"
        }
        
      ]
    };
  }
};
</script>